import { effect, inject, Injectable, signal } from '@angular/core';
import {
  NavSlimService,
  NavSlimVacationCookieData,
  NavSlimVacationSearchContent
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { VacationHeaderAdapter } from '../../../adapters/vacation-header/vacation-header.adapter';
import { VACATION_COOKIE_KEY } from '../../../constants/header-slim/header-slim.constants';

@Injectable({ providedIn: 'root' })
export class VacationHeaderFacadeService {
  private adapter = inject(VacationHeaderAdapter);
  private navSlimService = inject(NavSlimService);

  vacationCookieData = signal<NavSlimVacationCookieData | undefined>(undefined);
  vacationSearchContent = signal<NavSlimVacationSearchContent | undefined>(
    undefined
  );

  constructor() {
    effect(
      () => {
        const data = this.navSlimService.updateVacationData();
        if (data) {
          const transformData = this.adapter.transformFromInput(data);
          this.vacationSearchContent.set(
            this.adapter.toVacationSearchContent(transformData)
          );
        }
      },
      { allowSignalWrites: true }
    );
  }

  init(): void {
    this.getVacationDataCookieValues();
  }

  getVacationDataCookieValues(): void {
    const raw = sessionStorage.getItem(VACATION_COOKIE_KEY) ?? '';
    const data = this.adapter.transformFromCookie(raw);
    this.vacationCookieData.set(data);
    this.vacationSearchContent.set(this.adapter.toVacationSearchContent(data));
  }
}
